import { render, staticRenderFns } from "./UserFamilyChildren.vue?vue&type=template&id=29795ae8&scoped=true&"
import script from "./UserFamilyChildren.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildren.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyChildren.vue?vue&type=style&index=0&id=29795ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29795ae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29795ae8')) {
      api.createRecord('29795ae8', component.options)
    } else {
      api.reload('29795ae8', component.options)
    }
    module.hot.accept("./UserFamilyChildren.vue?vue&type=template&id=29795ae8&scoped=true&", function () {
      api.rerender('29795ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserFamilyChildren.vue"
export default component.exports